import { Text, View } from '@react-pdf/renderer';

import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { globalStyles } from '@composites/PDF/AgendaPdfContent/styles';
import { styles } from '../../styles';
import { useTranslation } from 'react-i18next';

interface PackagesPricesProps {
  event: PublicEventDetailsResponse;
}

const PackagesPrices = ({ event }: PackagesPricesProps) => {
  const { t } = useTranslation();
  return (
    <View style={styles.bodyContainer}>
      <View
        style={{
          ...styles.leftSideBody,
          backgroundColor: event.design.themeColor,
          flexDirection: 'column',
          gap: 10,
        }}
      >
        <Text style={styles.boldText}>{t('become-a-partner')}</Text>
      </View>
      <View style={{ ...styles.rightSideBody, gap: 20 }}>
        <Text style={styles.packagePriceSubtitle}>
          {t('packages-&-prices-subtitle')}
        </Text>
        <Text style={{ ...styles.title, width: 250 }}>
          {t('packages-&-prices')}
        </Text>
        <View
          style={{
            ...globalStyles.lineBar,
            marginRight: 'auto',
          }}
        />
      </View>
    </View>
  );
};

export default PackagesPrices;
